import { createSlice } from '@reduxjs/toolkit';

const platformScenes = createSlice({
  name: 'platformScenes',
  initialState: [],
  reducers: {
    setPlatformScenes: (_, action) => action.payload,
  },
});

export const { setPlatformScenes } = platformScenes.actions;
export const platformScenesReducer = platformScenes.reducer;
